//src/assets/icons/index.tsx
import { ReactComponent as AcceptIcon } from 'assets/icons/accept.svg';
import { ReactComponent as AccountantsIcon } from 'assets/icons/accountants.svg';
import { ReactComponent as AccountIcon } from 'assets/icons/account.svg';
import { ReactComponent as AddBlackIcon } from 'assets/icons/addBlack.svg';
import { ReactComponent as AddCircleIcon } from 'assets/icons/addCircle.svg';
import { ReactComponent as AddIcon } from 'assets/icons/add.svg';
import { ReactComponent as AILogo } from 'assets/icons/ai-logo.svg';
import { ReactComponent as AddressIcon } from 'assets/icons/Address.svg';
import { ReactComponent as AddRowIcon } from 'assets/icons/AddRow.svg';
import { ReactComponent as AddSmallIcon } from 'assets/icons/addSmall.svg';
import { ReactComponent as AmericanExpressIcon } from 'assets/icons/american-express.svg';
import { ReactComponent as ArchivedConversationsIcon } from 'assets/icons/archived-conversations.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';
import { ReactComponent as ArrowDownSolidIcon } from 'assets/icons/arrow-down-solid.svg';
import { ReactComponent as AttachIcon } from 'assets/icons/attach.svg';
import { ReactComponent as AccountingIcon } from 'assets/icons/Accounting.svg';
import { ReactComponent as COAIcon } from 'assets/icons/COA.svg';
import { ReactComponent as BirdLogo } from 'assets/icons/BirdLogoAOA.svg';
import { ReactComponent as BackIcon } from 'assets/icons/back.svg';
import { ReactComponent as BellIcon } from 'assets/icons/bell.svg';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { ReactComponent as CancelAssigneeIcon } from 'assets/icons/cancelAssignee.svg';
import { ReactComponent as CancelIcon } from 'assets/icons/cancel.svg';
import { ReactComponent as CartesBancairesIcon } from 'assets/icons/cartes-bancaires.svg';
import { ReactComponent as CheckedIcon } from 'assets/icons/checked.svg';
import { ReactComponent as CityIcon } from 'assets/icons/City.svg';
import { ReactComponent as CkeckSelectedIcon } from 'assets/icons/ckeckSelected.svg';
import { ReactComponent as ClientsIcon } from 'assets/icons/clients.svg';
import { ReactComponent as ClientSupportIcon } from 'assets/icons/client-support.svg';
import { ReactComponent as CloseRedIcon } from 'assets/icons/close-red.svg';
import { ReactComponent as CloudDownloadIcon } from 'assets/icons/cloud-download.svg';
import { ReactComponent as CommentIcon } from 'assets/icons/comment.svg';
import { ReactComponent as CompanyTypeIcon } from 'assets/icons/company-type.svg';
import { ReactComponent as ComposeConversationIcon } from 'assets/icons/compose-conversation.svg';
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg';
import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';
import { ReactComponent as CountryIcon } from 'assets/icons/Country.svg';
import { ReactComponent as CreateFolderGreenIcon } from 'assets/icons/create-folder-green.svg';
import { ReactComponent as CreditCardGenericIcon } from 'assets/icons/credit-card-generic.svg';
import { ReactComponent as DashboardIcon } from 'assets/icons/dashboard.svg';
import { ReactComponent as DeelIcon } from 'assets/icons/deel.svg';
import { ReactComponent as DelayIcon } from 'assets/icons/delay.svg';
import { ReactComponent as DeleteDarkIcon } from 'assets/icons/deleteDark.svg';
import { ReactComponent as DeleteDocumentIcon } from 'assets/icons/delete-document.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as DeleteIconIcon } from 'assets/icons/delete-icon.svg';
import { ReactComponent as DinersIcon } from 'assets/icons/diners.svg';
import { ReactComponent as DiscoverIcon } from 'assets/icons/discover.svg';
import { ReactComponent as DocIcon } from 'assets/icons/doc.svg';
import { ReactComponent as DocumentsIcon } from 'assets/icons/documents.svg';
import { ReactComponent as DocumentsZeroIcon } from 'assets/icons/documents-zero.svg';
import { ReactComponent as DownloadDocAdminIcon } from 'assets/icons/downloadDocAdmin.svg';
import { ReactComponent as DownloadFileIcon } from 'assets/icons/downloadFile.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { ReactComponent as DownloadWhiteIcon } from 'assets/icons/download-white.svg';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as EditPictureIcon } from 'assets/icons/editPicture.svg';
import { ReactComponent as EditSectionIcon } from 'assets/icons/editSection.svg';
import { ReactComponent as EmailFancyIcon } from 'assets/icons/email-fancy.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/email.svg';
import { ReactComponent as EmptyBoxIcon } from 'assets/icons/empty-box.svg';
import { ReactComponent as EnvelopeIcon } from 'assets/icons/envelope.svg';
import { ReactComponent as FileIcon } from 'assets/icons/file.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';
import { ReactComponent as FolderSolidIcon } from 'assets/icons/folder-solid.svg';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { ReactComponent as HistoryIcon } from 'assets/icons/history.svg';
import { ReactComponent as IndustryIcon } from 'assets/icons/industry.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/Info.svg';
import { ReactComponent as JcbcardIcon } from 'assets/icons/jcbcard.svg';
import { ReactComponent as JournalIcon } from 'assets/icons/Journal.svg';
import { ReactComponent as LanguageIcon } from 'assets/icons/Language.svg';
import { ReactComponent as LinkedInIcon } from 'assets/icons/LinkedIn.svg';
import { ReactComponent as LoginGreenIcon } from 'assets/icons/login-green.svg';
import { ReactComponent as LoginIcon } from 'assets/icons/login.svg';
import { ReactComponent as Magaphone2Icon } from 'assets/icons/magaphone2.svg';
import { ReactComponent as ManageProjectsIcon } from 'assets/icons/manageProjects.svg';
import { ReactComponent as ManageProjectsSolidIcon } from 'assets/icons/manage-projects-solid.svg';
import { ReactComponent as MastercardIcon } from 'assets/icons/mastercard.svg';
import { ReactComponent as MegaphoneIcon } from 'assets/icons/megaphone.svg';
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg';
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg';
import { ReactComponent as MessagesIcon } from 'assets/icons/messages.svg';
import { ReactComponent as MondayIcon } from 'assets/icons/monday.svg';
import { ReactComponent as MoveToIcon } from 'assets/icons/MoveTo.svg';
import { ReactComponent as NameIcon } from 'assets/icons/name.svg';
import { ReactComponent as NewDocumentIcon } from 'assets/icons/NewDocument.svg';
import { ReactComponent as NewfolderIcon } from 'assets/icons/Newfolder.svg';
import { ReactComponent as NextIcon } from 'assets/icons/next.svg';
import { ReactComponent as NotFoundIcon } from 'assets/icons/not-found.svg';
import { ReactComponent as OutlookIcon } from 'assets/icons/outlook.svg';
import { ReactComponent as OptionsIcon } from 'assets/icons/options.svg';
import { ReactComponent as OrdersIcon } from 'assets/icons/orders.svg';
import { ReactComponent as PaperClipIcon } from 'assets/icons/paper-clip.svg';
import { ReactComponent as PasswordFancyIcon } from 'assets/icons/password-fancy.svg';
import { ReactComponent as PasswordIcon } from 'assets/icons/password.svg';
import { ReactComponent as PasswordProfileIcon } from 'assets/icons/passwordProfile.svg';
import { ReactComponent as PaymentsIcon } from 'assets/icons/payments.svg';
import { ReactComponent as PdfIcon } from 'assets/icons/pdf.svg';
import { ReactComponent as PercentageIcon } from 'assets/icons/percentage.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg';
import { ReactComponent as PreviousDisabledIcon } from 'assets/icons/previousDisabled.svg';
import { ReactComponent as PreviousIcon } from 'assets/icons/previous.svg';
import { ReactComponent as PreviousWorkIcon } from 'assets/icons/previous-work.svg';
import { ReactComponent as ProfileClientIcon } from 'assets/icons/profile-client.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/profile.svg';
import { ReactComponent as ProjectsZeroIcon } from 'assets/icons/projects-zero.svg';
import { ReactComponent as ProconnectIcon } from 'assets/icons/Proconnect.svg';
import { ReactComponent as QuestionnaireDetailsIcon } from 'assets/icons/QuestionnaireDetails.svg';
import { ReactComponent as QuestionnairesIcon } from 'assets/icons/questionnaires.svg';
import { ReactComponent as QuestionnairesZeroIcon } from 'assets/icons/questionnaires-zero.svg';
import { ReactComponent as RejectIcon } from 'assets/icons/reject.svg';
import { ReactComponent as RemoveDocAdminIcon } from 'assets/icons/removeDocAdmin.svg';
import { ReactComponent as RemoveRowIcon } from 'assets/icons/RemoveRow.svg';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';
import { ReactComponent as ReuseIcon } from 'assets/icons/reuse.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { ReactComponent as SendMailIcon } from 'assets/icons/sendMail.svg';
import { ReactComponent as ServiceTypeIcon } from 'assets/icons/service-type.svg';
import { ReactComponent as ShareFolderIcon } from 'assets/icons/shareFolder.svg';
import { ReactComponent as ShareIcon } from 'assets/icons/share.svg';
import { ReactComponent as SlackIcon } from 'assets/icons/slack.svg';
import { ReactComponent as SignoutIcon } from 'assets/icons/signout.svg';
import { ReactComponent as SignUpGreenIcon } from 'assets/icons/sign-up-green.svg';
import { ReactComponent as SignUpIcon } from 'assets/icons/sign-up.svg';
import { ReactComponent as StarFillIcon } from 'assets/icons/star-fill.svg';
import { ReactComponent as StarIcon } from 'assets/icons/star.svg';
import { ReactComponent as StarredConversationsIcon } from 'assets/icons/starred-conversations.svg';
import { ReactComponent as StateIcon } from 'assets/icons/State.svg';
import { ReactComponent as SuccessFancyIcon } from 'assets/icons/success-fancy.svg';
import { ReactComponent as SpeakerOnIcon } from 'assets/icons/SpeakerOn.svg';
import { ReactComponent as SpeakerOffIcon } from 'assets/icons/SpeakerOff.svg';
import { ReactComponent as TasksIcon } from 'assets/icons/tasks.svg';
import { ReactComponent as TasksSolidIcon } from 'assets/icons/tasks-solid.svg';
import { ReactComponent as TeamIcon } from 'assets/icons/team.svg';
import { ReactComponent as TicketIcon } from 'assets/icons/ticket.svg';
import { ReactComponent as TimesheetIcon } from 'assets/icons/timesheet.svg';
import { ReactComponent as TimeZoneIcon } from 'assets/icons/time-zone.svg';
import { ReactComponent as TrashCanSolidIcon } from 'assets/icons/trash-can-solid.svg';
import { ReactComponent as UndeleteIcon } from 'assets/icons/undelete.svg';
import { ReactComponent as UnionpayIcon } from 'assets/icons/unionpay.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';
import { ReactComponent as UploadWhiteIcon } from 'assets/icons/upload-white.svg';
import { ReactComponent as VerticalOptionsIcon } from 'assets/icons/vertical-options.svg';
import { ReactComponent as ViewDetailsIcon } from 'assets/icons/ViewDetails.svg';
import { ReactComponent as ViewIcon } from 'assets/icons/view.svg';
import { ReactComponent as VisaIcon } from 'assets/icons/visa.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { ReactComponent as ZipcodeIcon } from 'assets/icons/Zipcode.svg';
import { ReactComponent as AndroidIcon } from 'assets/icons/AndroidApk.svg';
import { ReactComponent as IoSIcon } from 'assets/icons/IoSIcon.svg';
import { ReactComponent as QBOIcon } from 'assets/icons/Quickbooks.svg';

export {
  AcceptIcon,
  AccountantsIcon,
  AccountIcon,
  AddBlackIcon,
  AddCircleIcon,
  AddIcon,
  AddressIcon,
  AddRowIcon,
  AddSmallIcon,
  AmericanExpressIcon,
  AndroidIcon,
  IoSIcon,
  AILogo,
  ArchivedConversationsIcon,
  ArrowDownIcon,
  ArrowDownSolidIcon,
  AttachIcon,
  AccountingIcon,
  COAIcon,
  BackIcon,
  BellIcon,
  BirdLogo,
  CalendarIcon,
  CancelAssigneeIcon,
  CancelIcon,
  CartesBancairesIcon,
  CheckedIcon,
  CityIcon,
  CkeckSelectedIcon,
  ClientsIcon,
  ClientSupportIcon,
  CloseRedIcon,
  CloudDownloadIcon,
  CommentIcon,
  CompanyTypeIcon,
  ComposeConversationIcon,
  ComposeIcon,
  CopyIcon,
  CountryIcon,
  CreateFolderGreenIcon,
  CreditCardGenericIcon,
  DashboardIcon,
  DeelIcon,
  DelayIcon,
  DeleteDarkIcon,
  DeleteDocumentIcon,
  DeleteIcon,
  DeleteIconIcon,
  DinersIcon,
  DiscoverIcon,
  DocIcon,
  DocumentsIcon,
  DocumentsZeroIcon,
  DownloadDocAdminIcon,
  DownloadFileIcon,
  DownloadIcon,
  DownloadWhiteIcon,
  DuplicateIcon,
  EditIcon,
  EditPictureIcon,
  EditSectionIcon,
  EmailFancyIcon,
  EmailIcon,
  EmptyBoxIcon,
  EnvelopeIcon,
  FileIcon,
  FilterIcon,
  FolderSolidIcon,
  EyeIcon,
  HistoryIcon,
  IndustryIcon,
  InfoIcon,
  JcbcardIcon,
  JournalIcon,
  LanguageIcon,
  LinkedInIcon,
  LoginGreenIcon,
  LoginIcon,
  Magaphone2Icon,
  ManageProjectsIcon,
  ManageProjectsSolidIcon,
  MastercardIcon,
  MegaphoneIcon,
  MenuIcon,
  MessageIcon,
  MessagesIcon,
  MondayIcon,
  MoveToIcon,
  NameIcon,
  NewDocumentIcon,
  NewfolderIcon,
  NextIcon,
  NotFoundIcon,
  OutlookIcon,
  OptionsIcon,
  OrdersIcon,
  PaperClipIcon,
  PasswordFancyIcon,
  PasswordIcon,
  PasswordProfileIcon,
  PaymentsIcon,
  PdfIcon,
  PercentageIcon,
  PhoneIcon,
  PreviousDisabledIcon,
  PreviousIcon,
  PreviousWorkIcon,
  ProfileClientIcon,
  ProfileIcon,
  ProjectsZeroIcon,
  ProconnectIcon,
  QBOIcon,
  QuestionnaireDetailsIcon,
  QuestionnairesIcon,
  QuestionnairesZeroIcon,
  RejectIcon,
  RemoveDocAdminIcon,
  RemoveRowIcon,
  RestoreIcon,
  ReuseIcon,
  SaveIcon,
  SearchIcon,
  SendMailIcon,
  ServiceTypeIcon,
  ShareFolderIcon,
  ShareIcon,
  SlackIcon,
  SignoutIcon,
  SignUpGreenIcon,
  SignUpIcon,
  StarFillIcon,
  StarIcon,
  StarredConversationsIcon,
  StateIcon,
  SuccessFancyIcon,
  SpeakerOnIcon,
  SpeakerOffIcon,
  TasksIcon,
  TasksSolidIcon,
  TeamIcon,
  TicketIcon,
  TimesheetIcon,
  TimeZoneIcon,
  TrashCanSolidIcon,
  UndeleteIcon,
  UnionpayIcon,
  UploadIcon,
  UploadWhiteIcon,
  VerticalOptionsIcon,
  ViewDetailsIcon,
  ViewIcon,
  VisaIcon,
  WarningIcon,
  ZipcodeIcon,
};

export const IconsList = [
  { Component: AcceptIcon, name: 'AcceptIcon' },
  { Component: AccountantsIcon, name: 'AccountantsIcon' },
  { Component: AccountIcon, name: 'AccountIcon' },
  { Component: AddBlackIcon, name: 'AddBlackIcon' },
  { Component: AddCircleIcon, name: 'AddCircleIcon' },
  { Component: AddIcon, name: 'AddIcon' },
  { Component: AddressIcon, name: 'AddressIcon' },
  { Component: AddRowIcon, name: 'AddRowIcon' },
  { Component: AddSmallIcon, name: 'AddSmallIcon' },
  { Component: AmericanExpressIcon, name: 'AmericanExpressIcon' },
  { Component: AndroidIcon, name: 'AndroidIcon' },
  { Component: IoSIcon, name: 'IoSIcon' },
  { Component: ArchivedConversationsIcon, name: 'ArchivedConversationsIcon' },
  { Component: ArrowDownIcon, name: 'ArrowDownIcon' },
  { Component: ArrowDownSolidIcon, name: 'ArrowDownSolidIcon' },
  { Component: AttachIcon, name: 'AttachIcon' },
  { Component: AILogo, name: 'AILogo' },
  { Component: AccountingIcon, name: 'AccountingIcon' },
  { Component: COAIcon, name: 'COAIcon' },
  { Component: BackIcon, name: 'BackIcon' },
  { Component: BellIcon, name: 'BellIcon' },
  { Component: BirdLogo, name: 'BirdLogo' },
  { Component: CalendarIcon, name: 'CalendarIcon' },
  { Component: CancelAssigneeIcon, name: 'CancelAssigneeIcon' },
  { Component: CancelIcon, name: 'CancelIcon' },
  { Component: CartesBancairesIcon, name: 'CartesBancairesIcon' },
  { Component: CheckedIcon, name: 'CheckedIcon' },
  { Component: CityIcon, name: 'CityIcon' },
  { Component: CkeckSelectedIcon, name: 'CkeckSelectedIcon' },
  { Component: ClientsIcon, name: 'ClientsIcon' },
  { Component: ClientSupportIcon, name: 'ClientSupportIcon' },
  { Component: CloseRedIcon, name: 'CloseRedIcon' },
  { Component: CloudDownloadIcon, name: 'CloudDownloadIcon' },
  { Component: CommentIcon, name: 'CommentIcon' },
  { Component: CompanyTypeIcon, name: 'CompanyTypeIcon' },
  { Component: ComposeConversationIcon, name: 'ComposeConversationIcon' },
  { Component: ComposeIcon, name: 'ComposeIcon' },
  { Component: CopyIcon, name: 'CopyIcon' },
  { Component: CountryIcon, name: 'CountryIcon' },
  { Component: CreateFolderGreenIcon, name: 'CreateFolderGreenIcon' },
  { Component: CreditCardGenericIcon, name: 'CreditCardGenericIcon' },
  { Component: DashboardIcon, name: 'DashboardIcon' },
  { Component: DeelIcon, name: 'DeelIcon' },
  { Component: DelayIcon, name: 'DelayIcon' },
  { Component: DeleteDarkIcon, name: 'DeleteDarkIcon' },
  { Component: DeleteDocumentIcon, name: 'DeleteDocumentIcon' },
  { Component: DeleteIcon, name: 'DeleteIcon' },
  { Component: DeleteIconIcon, name: 'DeleteIconIcon' },
  { Component: DinersIcon, name: 'DinersIcon' },
  { Component: DiscoverIcon, name: 'DiscoverIcon' },
  { Component: DocIcon, name: 'DocIcon' },
  { Component: DocumentsIcon, name: 'DocumentsIcon' },
  { Component: DocumentsZeroIcon, name: 'DocumentsZeroIcon' },
  { Component: DownloadDocAdminIcon, name: 'DownloadDocAdminIcon' },
  { Component: DownloadFileIcon, name: 'DownloadFileIcon' },
  { Component: DownloadIcon, name: 'DownloadIcon' },
  { Component: DownloadWhiteIcon, name: 'DownloadWhiteIcon' },
  { Component: DuplicateIcon, name: 'DuplicateIcon' },
  { Component: EditIcon, name: 'EditIcon' },
  { Component: EditPictureIcon, name: 'EditPictureIcon' },
  { Component: EditSectionIcon, name: 'EditSectionIcon' },
  { Component: EmailFancyIcon, name: 'EmailFancyIcon' },
  { Component: EmailIcon, name: 'EmailIcon' },
  { Component: EmptyBoxIcon, name: 'EmptyBoxIcon' },
  { Component: EnvelopeIcon, name: 'EnvelopeIcon' },
  { Component: FileIcon, name: 'FileIcon' },
  { Component: FilterIcon, name: 'FilterIcon' },
  { Component: FolderSolidIcon, name: 'FolderSolidIcon' },
  { Component: EyeIcon, name: 'EyeIcon' },
  { Component: HistoryIcon, name: 'HistoryIcon' },
  { Component: IndustryIcon, name: 'IndustryIcon' },
  { Component: InfoIcon, name: 'InfoIcon' },
  { Component: JcbcardIcon, name: 'JcbcardIcon' },
  { Component: JournalIcon, name: 'JournalIcon' },
  { Component: LanguageIcon, name: 'LanguageIcon' },
  { Component: LinkedInIcon, name: 'LinkedInIcon' },
  { Component: LoginGreenIcon, name: 'LoginGreenIcon' },
  { Component: LoginIcon, name: 'LoginIcon' },
  { Component: Magaphone2Icon, name: 'Magaphone2Icon' },
  { Component: ManageProjectsIcon, name: 'ManageProjectsIcon' },
  { Component: ManageProjectsSolidIcon, name: 'ManageProjectsSolidIcon' },
  { Component: MastercardIcon, name: 'MastercardIcon' },
  { Component: MegaphoneIcon, name: 'MegaphoneIcon' },
  { Component: MenuIcon, name: 'MenuIcon' },
  { Component: MessageIcon, name: 'MessageIcon' },
  { Component: MessagesIcon, name: 'MessagesIcon' },
  { Component: MondayIcon, name: 'MondayIcon' },
  { Component: MoveToIcon, name: 'MoveToIcon' },
  { Component: NameIcon, name: 'NameIcon' },
  { Component: NewDocumentIcon, name: 'NewDocumentIcon' },
  { Component: NewfolderIcon, name: 'NewfolderIcon' },
  { Component: NextIcon, name: 'NextIcon' },
  { Component: NotFoundIcon, name: 'NotFoundIcon' },
  { Component: OptionsIcon, name: 'OptionsIcon' },
  { Component: OrdersIcon, name: 'OrdersIcon' },
  { Component: OutlookIcon, name: 'OutlookIcon' },
  { Component: PaperClipIcon, name: 'PaperClipIcon' },
  { Component: PasswordFancyIcon, name: 'PasswordFancyIcon' },
  { Component: PasswordIcon, name: 'PasswordIcon' },
  { Component: PasswordProfileIcon, name: 'PasswordProfileIcon' },
  { Component: PaymentsIcon, name: 'PaymentsIcon' },
  { Component: PdfIcon, name: 'PdfIcon' },
  { Component: PercentageIcon, name: 'PercentageIcon' },
  { Component: PhoneIcon, name: 'PhoneIcon' },
  { Component: PreviousDisabledIcon, name: 'PreviousDisabledIcon' },
  { Component: PreviousIcon, name: 'PreviousIcon' },
  { Component: PreviousWorkIcon, name: 'PreviousWorkIcon' },
  { Component: ProfileClientIcon, name: 'ProfileClientIcon' },
  { Component: ProfileIcon, name: 'ProfileIcon' },
  { Component: ProjectsZeroIcon, name: 'ProjectsZeroIcon' },
  { Component: ProconnectIcon, name: 'ProconnectIcon' },
  { Component: QBOIcon, name: 'QBOIcon' },
  { Component: QuestionnaireDetailsIcon, name: 'QuestionnaireDetailsIcon' },
  { Component: QuestionnairesIcon, name: 'QuestionnairesIcon' },
  { Component: QuestionnairesZeroIcon, name: 'QuestionnairesZeroIcon' },
  { Component: RejectIcon, name: 'RejectIcon' },
  { Component: RemoveDocAdminIcon, name: 'RemoveDocAdminIcon' },
  { Component: RemoveRowIcon, name: 'RemoveRowIcon' },
  { Component: RestoreIcon, name: 'RestoreIcon' },
  { Component: ReuseIcon, name: 'ReuseIcon' },
  { Component: SaveIcon, name: 'SaveIcon' },
  { Component: SearchIcon, name: 'SearchIcon' },
  { Component: SendMailIcon, name: 'SendMailIcon' },
  { Component: ServiceTypeIcon, name: 'ServiceTypeIcon' },
  { Component: ShareFolderIcon, name: 'ShareFolderIcon' },
  { Component: ShareIcon, name: 'ShareIcon' },
  { Component: SlackIcon, name: 'SlackIcon' },
  { Component: SignoutIcon, name: 'SignoutIcon' },
  { Component: SignUpGreenIcon, name: 'SignUpGreenIcon' },
  { Component: SignUpIcon, name: 'SignUpIcon' },
  { Component: StarFillIcon, name: 'StarFillIcon' },
  { Component: StarIcon, name: 'StarIcon' },
  { Component: StarredConversationsIcon, name: 'StarredConversationsIcon' },
  { Component: StateIcon, name: 'StateIcon' },
  { Component: SuccessFancyIcon, name: 'SuccessFancyIcon' },
  { Component: SpeakerOnIcon, name: 'SpeakerOnIcon' },
  { Component: SpeakerOffIcon, name: 'SpeakerOffIcon' },
  { Component: TasksIcon, name: 'TasksIcon' },
  { Component: TasksSolidIcon, name: 'TasksSolidIcon' },
  { Component: TeamIcon, name: 'TeamIcon' },
  { Component: TicketIcon, name: 'TicketIcon' },
  { Component: TimesheetIcon, name: 'TimesheetIcon' },
  { Component: TimeZoneIcon, name: 'TimeZoneIcon' },
  { Component: TrashCanSolidIcon, name: 'TrashCanSolidIcon' },
  { Component: UndeleteIcon, name: 'UndeleteIcon' },
  { Component: UnionpayIcon, name: 'UnionpayIcon' },
  { Component: UploadIcon, name: 'UploadIcon' },
  { Component: UploadWhiteIcon, name: 'UploadWhiteIcon' },
  { Component: VerticalOptionsIcon, name: 'VerticalOptionsIcon' },
  { Component: ViewDetailsIcon, name: 'ViewDetailsIcon' },
  { Component: ViewIcon, name: 'ViewIcon' },
  { Component: VisaIcon, name: 'VisaIcon' },
  { Component: WarningIcon, name: 'WarningIcon' },
  { Component: ZipcodeIcon, name: 'ZipcodeIcon' },
];
